import * as React from "react";
import { cn } from "@/lib/utils";
import { formatCount } from "../performance";

export interface StatTileProps {
  label: string;
  value: number;
  sub?: string;
  className?: string;
}

export function StatTile({ label, value, sub, className }: StatTileProps): JSX.Element {
  return (
    <div className={cn("rounded-xl border border-slate-200 bg-slate-50/60 p-3", className)} data-testid="stat-tile">
      <div className="text-[11px] uppercase font-bold text-slate-500">{label}</div>
      <div className="flex flex-wrap items-baseline gap-x-1.5">
        <span className="text-xl font-bold text-slate-800 tabular-nums">{formatCount(value)}</span>
        {sub && <span className="whitespace-nowrap text-[11px] text-slate-500 tabular-nums">{sub}</span>}
      </div>
    </div>
  );
}
